import { render, staticRenderFns } from "./subSideMenu.vue?vue&type=template&id=4440efe6"
import script from "./subSideMenu.vue?vue&type=script&lang=js"
export * from "./subSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports